var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "apply-success" }, [
    _c("div", { staticClass: "container text-center" }, [
      _vm.$attrs.application
        ? _c("div", [
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.t("form.submitted_msg")) },
            }),
            _vm._v(" "),
            _c("img", { attrs: { src: "/img/quotation.png" } }),
          ])
        : _vm.$attrs.quotation
        ? _c("div", [
            _c("h3", {
              domProps: { innerHTML: _vm._s(_vm.t("insurance.quotation_msg")) },
            }),
            _vm._v(" "),
            _c("img", { attrs: { src: "/img/quotation.png" } }),
          ])
        : _c("div", [
            _c("h3", {
              domProps: { innerHTML: _vm._s(_vm.t("insurance.applied_msg")) },
            }),
            _vm._v(" "),
            _c("img", { attrs: { src: "/img/handling.png" } }),
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-center" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary btn-md",
            on: { click: _vm.doneHandle },
          },
          [_vm._v("\n        " + _vm._s(_vm.t("filter.done")) + "\n      ")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }